<template>
  <div class="nav_smallbox">
    <div class="guanli_title">
      <span>实验管理</span>
    </div>
    <ul class="navList">
      <!-- <li @click="toshiyanzhongxin" :class="{ active: isActive == '/shouye' }"> -->
      <li @click="toshiyanzhongxin" :class="{ active: isActive == '/shouye' }">
        <i class="el-icon-collection"></i> <span>实验列表</span>
      </li>
      <li @click="tobianji" v-if="roles != 'student' && roles != '学生' && roles != 'visiter'"
        :class="{ active: isActive == '/bianji' || isActive == '/expbianji' }">
        <i class="el-icon-folder-add"></i> <span>实验编辑</span>
      </li>
      <li @click="totongji" :class="{ active: isActive == '/tongji' }">
        <i class="el-icon-pie-chart"></i> <span>学习统计</span>
      </li>
      <li @click="tojilu" :class="{ active: isActive == '/jilu' }">
        <i class="el-icon-reading"></i> <span>学习记录</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name:"index-nav",
  data() {
    return {
      // isActive: window.location.href.slice(26, 48),
      // isActive:window.location.href.split('/')[window.location.href.split('/').length - 1],
      isActive: this.$route.path,
      roles: localStorage.getItem('roles')
    };
  },
  methods: {
    toshiyanzhongxin() {
      this.$router.push({
        path: '/shouye',
      })
    },
    toziyuan() {
      this.$router.push({
        path: '/Resources',
      })
    },
    tobianji() {
      this.$router.push({
        path: '/expbianji',
      })
    },
    totongji() {
      this.$router.push({
        path: '/tongji',
      })
    },
    tojilu() {
      this.$router.push({
        path: '/jilu',
      })
    }
  },
  created() {
  },
}
</script>

<style lang="scss">
.nav_smallbox {
  width: 200px !important;
  max-height: 420px;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 20px;

  >.guanli_title {
    width: 100%;
    font-size: 24px;
    font-weight: 500;
    padding-bottom: 15px;
    border-bottom: 1px solid #999;
  }

  >.navList {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 30px;

    >li {
      padding: 10px 0;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 10px 0 !important;
      border-left: 2px solid transparent;

      >i {
        margin-right: 10px;
      }
    }

    >li:hover {
      background-color: #E5ECF5;
      border-left: 2px solid #0958d9;
    }

    .active {
      background-color: #E5ECF5;
      border-left: 2px solid #0958d9;
    }
  }
}
</style>
<style lang="scss" scoped>
@media (max-width:550px) {
  .guanli_title {
    display: none;
  }

  .nav_smallbox {
    width: 100% !important;
    min-height: auto !important;
    // background-color: red;
    padding: 0 !important;


    .navList {
      display: flex;
      flex-direction: row;
      margin: 0;
      background-color: rgba(235, 235, 235, 1);

      li {
        width: 25%;
        font-size: 14px;
        display: flex;
        align-items: center;

        i {
          margin-right: 5px;
          // margin: 0 5px 0 0;
          left: 20px;
          transition: all 0.3s;
          transform: translateX(-50%);
        }
      }
    }
  }
}
</style>
<style lang="">
  
</style>